'use strict';

function mode(key, mode) {
  if (key === 'localhost') return 'localhost';

  if (['standalone', 'producer', 'consumer'].indexOf(mode) === -1) throw 'Invalid mode provided';

  return mode;
}

module.exports = mode;


//////////////////
// WEBPACK FOOTER
// ../~/@splitsoftware/splitio/lib/utils/settings/mode.js
// module id = 1248
// module chunks = 0